"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Biography() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: copyRef,
    isVisible: copyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const values = [{
    label: "Concierge Privacy",
    description: "Experience discreet, personalized care in a private, luxury setting."
  }, {
    label: "Facial Balancing",
    description: "Refining your unique proportions for a natural, refreshed appearance."
  }, {
    label: "Preventative Care",
    description: "Using fillers and neurotoxins to support skin health before lines deepen."
  }, {
    label: "Effortless Results",
    description: "Expertly administered treatments that restore symmetry and confidence."
  }];
  return <section data-section-id="19019" id="ownerbiography" className="bg-background text-foreground py-28 md:py-36">
      <div className="container mx-auto max-w-7xl px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div ref={imageRef} className="lg:col-span-5 transition-all duration-[720ms] ease-out" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateY(0)" : "translateY(16px)"
        }}>
            <div className="overflow-hidden aspect-square lg:aspect-[4/5] group rounded-lg shadow-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728549/img/botox-specialist-san-antonio.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728549/img/botox-specialist-san-antonio.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728549/img/botox-specialist-san-antonio.webp-wvc-sizes" alt="Dr. Amber Ojeda providing a personalized aesthetic consultation" loading="lazy" decoding="async" className="w-full h-full object-cover object-top lg:object-center transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]" />
            </div>
            <p className="text-sm text-muted-foreground mt-4 italic">Dr. Amber Ojeda, DNP, APRN, FNP‑C is proud to work under the medical direction of Dr. James Otis Hill II, DO</p>
          </div>

          {}
          <div ref={copyRef} className="lg:col-span-7 lg:mt-16 transition-all duration-[720ms] ease-out" style={{
          opacity: copyVisible ? 1 : 0,
          transform: copyVisible ? "translateY(0)" : "translateY(16px)",
          transitionDelay: copyVisible ? "80ms" : "0ms"
        }}>
            <p className="font-default text-[0.8125rem] md:text-sm font-medium uppercase text-accent-foreground/80 leading-none mb-6" style={{
            letterSpacing: "0.14em"
          }}>
              Our Approach
            </p>

            <h2 className="font-default text-foreground" style={{
            fontSize: "clamp(2.125rem, 3.8vw, 3.375rem)",
            fontWeight: 600,
            letterSpacing: "-0.018em",
            lineHeight: 1.1
          }}>
              Refined aesthetics, tailored to{" "}
              <span className="italic text-primary inline-block transition-all duration-[520ms] ease-out" style={{
              opacity: copyVisible ? 1 : 0,
              transform: copyVisible ? "translateY(0)" : "translateY(4px)",
              transitionDelay: copyVisible ? "280ms" : "0ms"
            }}>
                you
              </span>
            </h2>

            <p className="font-default text-foreground mt-6" style={{
            fontSize: "clamp(1.125rem, 1.25vw, 1.3125rem)",
            lineHeight: 1.7,
            color: "var(--muted-foreground)"
          }}>At Ideal Image Aesthetics and Wellness, LLC we believe in the art of subtle enhancement. Dr. Ojeda, FNP combines clinical precision with a concierge experience, ensuring your journey toward facial balancing is as seamless and luxurious as the results themselves.</p>

            {}
            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8">
              {values.map((value, i) => <div data-index={i} key={i}>
                  <h4 className="font-default text-foreground" style={{
                fontWeight: 600,
                fontSize: "1.0625rem",
                letterSpacing: "0.005em",
                lineHeight: 1.35
              }}>
                    {value.label}
                  </h4>
                  <p className="font-default text-muted-foreground mt-2" style={{
                fontSize: "0.9375rem",
                lineHeight: 1.5
              }}>
                    {value.description}
                  </p>
                </div>)}
            </div>

            {}
            <div className="mt-12">
              <Link to="/ExperiencePage" className="inline-block font-default text-foreground hover:text-primary transition-all duration-300" style={{
              textDecoration: "underline",
              textDecorationColor: "var(--primary)",
              textDecorationThickness: "1.5px",
              textUnderlineOffset: "6px"
            }}>
                Discover our aesthetic philosophy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}